// frontend/src/pages/VideoById.js
// ===============================================================
// 🔥 Page vidéo CONTEXTUELLE (profil ou feed)
// Swipe VERTICAL = vidéos
// Swipe DROITE = profil utilisateur
// ===============================================================

import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../axiosInstance";
import { UPLOADS_URL } from "../config";
import VideoSidebar from "../components/VideoSidebar";
import "../styles/TikTokFeed.css";

export default function VideoById() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [videos, setVideos] = useState([]);
  const playerRefs = useRef([]);

  // 👉 refs swipe
  const touchStartX = useRef(0);
  const touchStartY = useRef(0);

  // ===============================================================
  // 📌 Charger la vidéo cliquée + vidéos du MÊME auteur
  // ===============================================================
  useEffect(() => {
    const load = async () => {
      try {
        const one = await axios.get(`/videos/${id}`);
        const video = one.data;
        if (!video || !video.user_email) return;

        const res = await axios.get(
          `/videos/by-user/${encodeURIComponent(video.user_email)}`
        );

        const list = Array.isArray(res.data) ? res.data : [];

        const index = list.findIndex((v) => v.id === Number(id));
        if (index !== -1) {
          setVideos([...list.slice(index), ...list.slice(0, index)]);
        } else {
          setVideos(list);
        }
      } catch (err) {
        console.error("❌ Erreur chargement vidéo :", err);
      }
    };

    load();
  }, [id]);

  // ===============================================================
  // 📌 Auto play / pause vertical
  // ===============================================================
  const handleIntersection = (entries) => {
    entries.forEach((entry) => {
      const video = entry.target.querySelector("video");
      if (!video) return;
      entry.isIntersecting ? video.play() : video.pause();
    });
  };

  useEffect(() => {
    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.6,
    });

    playerRefs.current.forEach((ref) => ref && observer.observe(ref));
    return () => observer.disconnect();
  }, [videos]);

  // ===============================================================
  // 📌 Swipe horizontal → PROFIL
  // ===============================================================
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    touchStartY.current = e.touches[0].clientY;
  };

  const handleTouchEnd = (e, video) => {
    const endX = e.changedTouches[0].clientX;
    const endY = e.changedTouches[0].clientY;

    const deltaX = endX - touchStartX.current;
    const deltaY = endY - touchStartY.current;

    // ignore scroll vertical
    if (Math.abs(deltaX) < Math.abs(deltaY)) return;

    // swipe droite → profil
    if (deltaX > 80 && video?.user_pseudo) {
      navigate(`/user/${video.user_pseudo}`);
    }
  };

  // ===============================================================
  // 📌 URL vidéo
  // ===============================================================
  const getCleanVideoUrl = (filePath) => {
    if (!filePath) return "";
    const clean = filePath
      .replace(/^\/+/, "")
      .replace(/^uploads\//, "")
      .replace(/^videos\//, "");
    return `${UPLOADS_URL}/videos/${clean}`;
  };

  // ===============================================================
  // 🔥 RENDER
  // ===============================================================
  return (
    <div className="tiktok-feed">
      {videos.map((video, index) => {
        const videoUrl = getCleanVideoUrl(video.file_path);

        return (
          <div
            key={video.id}
            className="tiktok-video"
            ref={(el) => (playerRefs.current[index] = el)}
          >
            {/* 🎬 VIDEO */}
            <video
              className="tiktok-player"
              src={videoUrl}
              loop
              playsInline
            />

            {/* 👉 COUCHE INVISIBLE POUR LE SWIPE */}
            <div
              className="swipe-layer"
              onTouchStart={handleTouchStart}
              onTouchEnd={(e) => handleTouchEnd(e, video)}
            />

            <VideoSidebar video={video} />
          </div>
        );
      })}
    </div>
  );
}
